
import Vue from 'vue';
import Vuex from 'vuex';

// modules
import cart from './modules/cart';
import collections from './modules/collections';
import params from './modules/params';
import products from './modules/products';
import productPage from './modules/product-page';
import toast from './modules/toast';
import scroll from './modules/scroll';
import storefront from './modules/storefront';
import reviews from './modules/reviews';
import video from './modules/video';

Vue.use(Vuex);

const state = {};

export default new Vuex.Store({
  state,
  modules: {
    cart,
    collections,
    params,
    products,
    productPage,
    toast,
    scroll,
    storefront,
    reviews,
    video,
  },
});
